// extracted by mini-css-extract-plugin
module.exports = {"bottles":"_3AlP3n","bottle":"_3isudU","title":"_3hDuX-"};